var _desc, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUnitHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 59,
    viewBox: "0 0 77 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-4264 -321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(4264 321)",
    fill: "#FFFFFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    fillRule: "evenodd",
    d: "M 21.1727 39.9385L 13.4818 39.9385L 13.4818 47.6538L 21.1727 47.6538L 21.1727 39.9385ZM 74.4665 26.8677L 74.4665 56.4585L 44.879 56.4585L 44.879 37.3969L 32.121 37.3969L 32.121 56.4585L 2.53349 56.4585L 2.53349 26.8677L 26.2397 26.8677L 38.5452 13.7969L 50.8508 26.8677L 74.4665 26.8677ZM 3.61927 24.3262L 25.0635 24.3262L 38.5452 9.98462L 51.9365 24.2354L 73.3807 24.2354L 54.3796 2.54154L 22.7109 2.54154L 3.61927 24.3262ZM 77 24.5985L 77 59L 42.3455 59L 42.3455 39.9385L 34.6545 39.9385L 34.6545 59L 0 59L 0 24.5985L 21.5347 0L 55.4653 0L 77 24.5985ZM 63.5182 39.9385L 55.8273 39.9385L 55.8273 47.6538L 63.5182 47.6538L 63.5182 39.9385ZM 66.0517 37.3969L 53.2938 37.3969L 53.2938 50.1954L 66.0517 50.1954L 66.0517 37.3969ZM 23.7062 37.3969L 23.7062 50.1954L 10.9483 50.1954L 10.9483 37.3969L 23.7062 37.3969Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnitHome);
export default __webpack_public_path__ + "static/media/icon-unit-home.b5fac0797290c0b22b751cc238372ee0.svg";
export { ForwardRef as ReactComponent };